import { SuspendMatch as SuspendMatchComponent } from './SuspendMatch.component';
import { connector } from './SuspendMatch.connector';

export const SuspendMatch = connector(SuspendMatchComponent);
